import React, { useContext } from 'react';
import { ICreateVideoContext, CreateVideoContext } from '../../../createVideoState/createVideoContext';
import { TranslationForm } from 'components/TranslationForm/TranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setTranslationTab,
		changeNameTranslation,
		IDsSelectedLanguages,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
	} = useContext<ICreateVideoContext>(CreateVideoContext);
	return (
		<TranslationForm
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDsSelectedLanguages={IDsSelectedLanguages}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			fetchedLanguages={fetchedLanguages}
		/>
	);
};

export default TranslationsForm;
